// eslint-disable-next-line import/no-cycle
import { ActivityItem } from '@/services/undergrad/pegasus-pepe-legal/user-grades.service';

export enum ActivityItemStatus {
  DONE = 'DONE',
  PENDING = 'PENDING',
  BLOCKED = 'BLOCKED',
  WAITING = 'WAITING',
  DONE_DELAYED = 'DONE_DELAYED',
  PENDING_DELAYED = 'PENDING_DELAYED',
  WAITING_DELAYED = 'WAITING_DELAYED',
  CANCELLED = 'CANCELLED',
  CANCELLED_DELAYED = 'CANCELLED_DELAYED',
}

export interface IActivityItem extends ActivityItem {}

export enum GradeComponentType {
  EXERCISE = 'exercise',
  TRIVIA = 'trivia',
  PRACTICE = 'practice',
  GENERIC = 'generic',
  REVIEW_LIST = 'reviewList',
  EXAM = 'finalExam',
}

export enum GradeCommentType {
  ACED = 'aced',
  ACING = 'acing',
  PASSED = 'passed',
  FAILED = 'failed',
  IN_PROGRESS = 'inProgress',
  PASSED_WAITING_EXAM = 'passedWaitingExam',
  FAILED_WAITING_EXAM = 'failedWaitingExam',
}

export interface IGradeCommentInfo {
  type: GradeCommentType;
  points: number;
}
